import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LS_SELECTED_DOMAIN_KEY } from 'shared/constants/localstorage';
import { Project } from 'store/api/apiTypes';
import { userApiSlice } from 'store/api/userApiSlice';

interface ProjectState {
  selectedProject: Project | null;
}

const initialState: ProjectState = {
  selectedProject: null,
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setSelectedProject: (state, action: PayloadAction<Project | null>) => {
      state.selectedProject = action.payload;
      if (action.payload) {
        localStorage.setItem(LS_SELECTED_DOMAIN_KEY, action.payload.domain);
      }
    },
    clearSelectedProject: state => {
      state.selectedProject = null;
    },
  },
  extraReducers: builder => {
    // Auto-set selected project when user info is loaded
    builder.addMatcher(
      userApiSlice.endpoints.getUserInfo.matchFulfilled,
      (state, action) => {
        const active = action.payload.activeDomains || [];
        // If no selection yet, choose first active domain
        if (!state.selectedProject) {
          const storedDomain = localStorage.getItem(LS_SELECTED_DOMAIN_KEY);
          if (storedDomain) {
            const storedProject = active.find(d => d.domain === storedDomain);
            if (storedProject) {
              state.selectedProject = storedProject;
              return;
            }
          }
          state.selectedProject = active[0];
          localStorage.setItem(
            LS_SELECTED_DOMAIN_KEY,
            state.selectedProject?.domain || ''
          );
          return;
        }
        // If we already have a selected domain, refresh its data from active list (paid status may have changed)
        const updated = active.find(
          d => d.domain === state.selectedProject?.domain
        );
        if (updated) {
          state.selectedProject = updated;
        } else if (active[0]) {
          // Fallback: previous selected domain no longer active? Select first active
          state.selectedProject = active[0];
        }
      }
    );
  },
});

export const { setSelectedProject, clearSelectedProject } =
  projectSlice.actions;
export default projectSlice.reducer;
